<template>
  <div>
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <div
      style="box-shadow: 0px 2px 20px 0px #105c8e26"
      class="bg-white px-10 py-5 rounded-2xl"
    >
      <!-- <h3 class="text-sm font-semibold text-blues mb-2">Single Upload Form</h3> -->
      <form
        @submit.prevent="singleSubmit"
        class="space-y-4 text-sm"
        ref="addRefs"
      >
        <!-- Name -->
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div>
            <label
              for="firstName"
              class="block text-sm font-medium text-gray-700 mb-1"
              >First Name <span class="text-red-400">*</span></label
            >
            <input
              id="firstName"
              type="text"
              placeholder="First Name"
              v-model="firstName"
              class="w-full p-2 border border-gray-300 rounded"
              required
            />
          </div>
          <div>
            <label
              for="lastName"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Last Name
            </label>
            <input
              id="lastName"
              type="text"
              placeholder="Last Name"
              v-model="lastName"
              class="w-full p-2 border border-gray-300 rounded"
            />
          </div>
          <div>
            <label
              for="email"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Email ID <span class="text-red-400">*</span></label
            >
            <input
              id="email"
              type="email"
              placeholder="Email ID"
              v-model="email"
              @input="email = email.toLowerCase()"
              class="w-full p-2 border border-gray-300 rounded"
              required
            />
          </div>
          <div>
            <label class="block font-medium text-gray-700 mb-1"
              >Password <span class="text-red-400">*</span></label
            >
            <div class="flex gap-4 mb-2">
              <label class="flex items-center space-x-2 cursor-pointer">
                <input
                  type="radio"
                  id="passwordCustom"
                  value="custom"
                  v-model="passwordOption"
                  class="form-radio text-blue-500"
                />
                <span>Custom</span>
              </label>
              <label class="flex items-center space-x-2 cursor-pointer">
                <input
                  type="radio"
                  id="passwordAuto"
                  value="auto"
                  v-model="passwordOption"
                  class="form-radio text-blue-500"
                />
                <span>Auto Generate</span>
              </label>
            </div>

            <div v-if="passwordOption === 'custom'">
              <label
                for="password"
                class="block text-sm font-medium text-gray-700 mb-1"
                >Custom Password</label
              >
              <input
                id="password"
                type="password"
                placeholder="Enter Password"
                v-model="password"
                class="w-full p-2 border border-gray-300 rounded"
                required
              />
            </div>

            <div v-if="passwordOption === 'auto'">
              <label
                for="password"
                class="block text-sm font-medium text-gray-700 mb-1"
                >Generated Password</label
              >
              <input
                id="password"
                type="text"
                :value="password"
                readonly
                class="w-full p-2 border border-gray-300 rounded bg-gray-100"
              />
            </div>
          </div>
          <div class="mt-auto">
            <label
              for="countryCode"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Mobile Number <span class="text-red-400">*</span></label
            >
            <div class="flex">
              <select
                id="country-form"
                v-model="countryCode"
                @change="setPhoneLength(countryCode)"
                required
                class="w-20 px-3 py-2 border border-gray-300 rounded"
              >
                <option value="" disabled>Select an option</option>
                <option
                  v-for="country in countryCodes"
                  :key="country.code"
                  :value="country.code"
                >
                  {{
                    countryCode === country.code
                      ? country.code
                      : `${country.name} (${country.code})`
                  }}
                </option>
              </select>
              <input
                type="tel"
                v-model="mobile"
                required
                class="w-full p-2 border border-gray-300 rounded"
                onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                id="Phone_no"
                placeholder="Phone no"
                :maxlength="max_length"
              />
            </div>
            <span class="text-xs font-normal" v-if="phone_max_length"
              >Please Enter
              <b>{{ phone_max_length }}</b>
              Digit Phone Number</span
            >
          </div>

          <!-- Password Option -->

          <div class="mt-auto">
            <label
              for="applicationNumber"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Application Number <span class="text-red-400">*</span></label
            >
            <input
              id="applicationNumber"
              type="text"
              placeholder="Application Number"
              v-model="applicationNumber"
              class="w-full p-2 border border-gray-300 rounded"
              required
            />
          </div>
          <div>
            <label
              for="universalRegNumber"
              class="block text-sm font-medium text-gray-700 mb-1"
            >
              Permanent Registration Number
            </label>
            <input
              id="universalRegNumber"
              type="text"
              placeholder="Enter Permanent Registration Number"
              v-model="universalRegNumber"
              class="w-full p-2 border border-gray-300 rounded"
            />
          </div>
          <div>
            <label
              for="Batch"
              class="block text-sm font-medium text-gray-700 mb-1"
            >
              Batch <span class="text-red-400">*</span>
            </label>
            <select
              id="Batch"
              v-model="Batch"
              @change="onBatchChange"
              class="w-full p-2 border border-gray-300 rounded"
              required
            >
              <option value="" selected disabled>Select Batch</option>
              <option
                v-for="batch in batchs"
                :key="batch.year"
                :value="batch.id"
              >
                {{ batch.year }}
              </option>
            </select>
          </div>
          <div>
            <label
              for="selectField"
              class="block text-sm font-medium text-gray-700 mb-1"
            >
              Program <span class="text-red-400">*</span>
            </label>
            <select
              id="selectField"
              v-model="Program"
              @change="onProgramChange"
              :disabled="!Batch"
              class="w-full p-2 border border-gray-300 rounded"
              :class="{ 'bg-gray-100 cursor-not-allowed': !Batch }"
              required
            >
              <option value="" disabled selected>Select Program</option>
              <option
                v-for="program in programs"
                :key="program.id"
                :value="program.id"
              >
                {{ program.name }}
              </option>
            </select>
          </div>

          <!-- Department (Auto-selected based on Program) -->
          <div class="hidden">
            <label
              for="department"
              class="block text-sm font-medium text-gray-700 mb-1"
            >
              Department <span class="text-red-400">*</span>
            </label>
            <select
              id="department"
              v-model="department"
              required
              :disabled="!Program"
              class="w-full p-2 border border-gray-300 rounded"
              :class="{ 'bg-gray-100 cursor-not-allowed': !Program }"
            >
              <option value="" disabled selected>Select Department</option>
              <option
                v-for="department in departments"
                :key="department.id"
                :value="department.id"
              >
                {{ department.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="flex justify-end">
          <!-- <button
            type="submit"
            class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Submit
          </button> -->
          <div class="flex items-center gap-3">
            <button
              type="submit"
              :disabled="disable_submit == true"
              :class="
                this.disable_submit == true
                  ? 'bg-gray-200 text-black cursor-not-allowed'
                  : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
              "
              class="rounded-lg text-sm px-6 py-2"
            >
              Submit
            </button>
            <img
              v-if="disable_submit"
              src="@/assets/loading.gif"
              alt="loading"
              class="w-6 h-6 object-contain"
            />
          </div>
        </div>
      </form>
    </div>

    <!-- Heading + Search bar row -->
    <div class="flex items-center justify-between mt-6 mb-4">
      <div class="flex items-center gap-2">
        <h2 class="text-lg font-semibold">Submitted Data</h2>
        <span v-if="studentcount" class=""> ({{ studentcount }}) </span>
      </div>

      <div class="relative w-full md:max-w-80">
        <div
          class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 text-gray-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
        </div>
        <input
          type="text"
          v-model="searching"
          @input="getsubmit(1)"
          placeholder="Search..."
          class="w-full rounded-xl border border-gray-200 bg-white pl-10 pr-10 py-2 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
        />
        <button
          v-if="searching"
          @click="clearSearch"
          class="absolute inset-y-0 right-0 pr-3 flex items-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 text-gray-400 hover:text-gray-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
    </div>

    <!-- Table -->
    <div v-if="submittedData.length > 0" class="pb-20">
      <div
        class="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-x-auto"
      >
        <table class="min-w-full text-sm">
          <thead class="bg-gray-100">
            <tr>
              <th
                class="py-3 px-4 border-b border-r font-semibold text-blues text-left"
              >
                S.NO
              </th>
              <th
                class="py-3 px-4 border-b border-r font-semibold text-blues text-left"
              >
                Student Identity
              </th>
              <th
                class="py-3 px-4 border-b border-r font-semibold text-blues text-left"
              >
                Mobile No
              </th>
              <th
                class="py-3 px-4 border-b border-r font-semibold text-blues text-left whitespace-nowrap"
              >
                Program & Batch
              </th>
              <th
                class="py-3 px-4 border-b border-r font-semibold text-blues text-left whitespace-nowrap"
              >
                Permanent Reg No
              </th>
              <th
                class="py-3 px-4 border-b border-r font-semibold text-blues text-left whitespace-nowrap"
              >
                Application No
              </th>
              <th
                class="py-3 px-4 border-b border-r font-semibold text-blues text-left"
              >
                Created Date
              </th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 bg-white">
            <tr
              v-for="(item, index) in submittedData"
              :key="index"
              class="hover:bg-gray-50 transition whitespace-nowrap"
            >
              <td class="py-3 px-4 border-r text-left text-gray-700">
                {{ (currentPage - 1) * pageSize + index + 1 }}
              </td>
              <td class="py-3 px-4 border-r text-left text-gray-700">
                <div class="flex items-center gap-2">
                  <div
                    class="w-7 h-7 flex-shrink-0 rounded-full uppercase bg-indigo-50 flex items-center justify-center text-[10px] font-bold text-indigo-600"
                  >
                    {{ item.first_name.charAt(0) || "?" }}
                  </div>
                  <div class="flex flex-col min-w-0">
                    <span
                      class="text-xs font-semibold text-slate-700 uppercase"
                    >
                      {{ item.first_name }} {{ item.last_name }}
                    </span>
                    <div
                      class="text-[12px] text-gray-500 flex items-center gap-1"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="12px"
                        viewBox="0 -960 960 960"
                        width="12px"
                        fill="#9CA3AF"
                      >
                        <path
                          d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z"
                        />
                      </svg>
                      {{ item.email || "NA" }}
                    </div>
                  </div>
                </div>
              </td>
              <td
                class="py-3 px-4 border-r text-left text-xs text-gray-500 font-medium"
              >
                {{ item.phone_number || "NA" }}
              </td>
              <td class="py-3 px-4 border-r text-left text-gray-700">
                <div class="text-xs text-gray-900 font-medium">
                  {{ item.program }}
                </div>
                <div class="text-xs text-gray-500">
                  Batch: {{ item.batch || "NA" }}
                </div>
              </td>
              <td
                class="py-3 px-4 border-r text-left text-xs text-gray-500 font-medium"
              >
                {{ item.prn_number || "NA" }}
              </td>
              <td
                class="py-3 px-4 border-r text-left text-xs text-gray-500 font-medium"
              >
                {{ item.application_number || "NA" }}
              </td>
              <td
                class="py-3 px-4 border-r text-left text-xs text-gray-500 font-medium"
              >
                {{ item.created_at ? formatDate(item.created_at) : "NA" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination row -->
      <div
        class="flex flex-col sm:flex-row justify-center gap-3 pb-[20px] relative mt-3"
      >
        <div
          class="md:absolute md:left-3 md:top-4 gap-2 text-sm text-gray-600 flex justify-center items-center"
        >
          <select
            v-model="pageSize"
            @change="onPageSizeChange"
            class="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option :value="10">10</option>
            <option :value="20">20</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
          </select>
        </div>
        <div v-if="totalPages > 1" class="flex justify-center">
          <Pagination
            :totalPages="totalPages"
            ref="paginationRef"
            @page-changed="getsubmit"
          />
        </div>
      </div>
    </div>
    <div v-else class="mt-4 text-gray-500 text-sm">No Data Found</div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import countryCodeMixins from "@/mixins/countryCodeMixins";
import phoneLength from "@/mixins/phoneLength";
import FlashMessage from "@/components/FlashMessage.vue";
import Pagination from "@/components/Pagination.vue";

export default {
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      countryCode: "+91",
      phone_max_length: "",
      mobile: "",
      passwordOption: "custom",
      password: "",
      applicationNumber: "",
      Program: "",
      Batch: "",
      searching: "",
      universalRegNumber: "",
      department: "",

      max_length: 10,
      programs: [],
      departments: [],
      batchs: [],
      messages: {
        text: "",
        type: "null",
      },
      submittedData: [],
      totalPages: 1,
      currentPage: 1,
      studentcount: "",
      disable_submit: false,
      pageSize: 10,
    };
  },
  components: {
    FlashMessage,
    Pagination,
  },
  mixins: [countryCodeMixins, phoneLength],
  watch: {
    passwordOption(newVal) {
      if (newVal === "auto") {
        this.password = this.generatePassword();
      } else {
        this.password = "";
      }
    },
  },
  computed: mapGetters(["userInfo"]),
  async created() {
    // this.getPrograms();
    // this.getDepartments();
    await this.batchget();
    this.getsubmit(1);
  },
  mounted() {},
  methods: {
    clearSearch() {
      this.searching = "";
      this.getsubmit(1);
    },
    formatErrorMessage(message) {
      if (!message) return "Something went wrong. Please try again.";
      if (typeof message === "string") return message;

      const firstKey = Object.keys(message)[0];
      const firstError = Array.isArray(message[firstKey])
        ? message[firstKey][0]
        : message[firstKey];

      return firstError || "Something went wrong. Please try again.";
    },
    onPageSizeChange() {
      this.currentPage = 1;
      if (this.$refs.paginationRef) {
        this.$refs.paginationRef.currentPage = 1;
      }
      this.getsubmit(1);
    },
    formatDate(date) {
      if (!date) return "";

      const d = new Date(date);

      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");

      let hours = d.getHours();
      const minutes = String(d.getMinutes()).padStart(2, "0");
      const seconds = String(d.getSeconds()).padStart(2, "0");

      const ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12 || 12;
      hours = String(hours).padStart(2, "0");

      return `${yyyy}-${mm}-${dd}, ${hours}:${minutes}:${seconds} ${ampm}`;
    },
    generatePassword() {
      return Math.random().toString(36).slice(-8);
    },
    async onBatchChange() {
      this.Program = "";
      this.department = "";
      this.programs = [];
      this.departments = [];

      if (this.Batch) {
        await this.getProgramsByBatch(this.Batch);
      }
    },
    async getProgramsByBatch(batchId) {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API}/program-list/?batch__id=${batchId}&Key=${this.userInfo.token_key}`,
        );
        this.programs = res.data.data || [];
      } catch (err) {
        console.error("Error fetching programs:", err);
        this.programs = [];
      }
    },
    async onProgramChange() {
      this.department = "";
      this.departments = [];

      if (this.Program) {
        await this.getDepartmentsByProgram(this.Program);
      }
    },
    async getDepartmentsByProgram(programId) {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API}/department-list/?Key=${this.userInfo.token_key}&program__id=${programId}`,
        );
        this.departments = res.data.data || [];

        if (this.departments.length > 0) {
          this.department = this.departments[0].id;
        }
      } catch (err) {
        console.error("Error fetching departments:", err);
        this.departments = [];
      }
    },

    async batchget() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/batch-filter-list/?Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          if (res.data.data.status == 200) {
            this.batchs = res.data.data.data;
          }
        })
        .catch((err) => {
          console.error("Error fetching batches:", err);
          this.batchs = [];
        });
    },
    setPhoneLength(phone) {
      const phone_length = this.phoneNumberLengths.filter((item) => {
        return item.phone == phone;
      });
      if (phone_length.length > 0) {
        this.max_length = phone_length[0].phoneLength;
      }
      if (phone == this.selectedCountryCode) {
        this.new_max_length = this.max_length;
      } else {
        this.phone_max_length = this.max_length;
      }
    },
    singleSubmit() {
      console.log("sdfdfsdf");
      this.disable_submit = true;
      const beforeData = {
        first_name: this.firstName,
        last_name: this.lastName,
        email: this.email,
        custom_password: this.password,
        auto_generative_password: this.password,
        country_code: this.countryCode,
        phone_number: this.countryCode + " " + this.mobile,
        application_number: this.applicationNumber,
        prn_number: this.universalRegNumber,
        user: this.userInfo.user.id,
        // role: this.selected_seat_type,
        program: this.Program,
        batch: this.Batch,
        department: this.department,
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/user/signup/?Key=${this.userInfo.token_key}`,
          beforeData,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            this.getsubmit(1);
            // this.$refs.addRefs.reset();

            this.firstName = "";
            this.lastName = "";
            this.email = "";
            this.password = "";
            this.countryCode = "+91";
            this.passwordOption="custom";
            this.mobile = "";
            this.applicationNumber = "";
            this.universalRegNumber = "";
            this.Program = "";
            this.Batch = "";
            this.department = "";
            this.programs = [];
            this.departments = [];
            this.disable_submit = false;
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 1500);
          } else {
            this.messages = {
              text: this.formatErrorMessage(response.data.message),
              type: "error",
            };
            this.disable_submit = false;
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        })
        .finally(() => {
          this.disable_submit = false;
        });
    },
    getsubmit(number) {
      this.currentPage = number;
      axios
        .get(
          `${process.env.VUE_APP_API}/enrollment-list/?Key=${this.userInfo.token_key}&page=${number}&page_size=${this.pageSize}&search=${this.searching} `,
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            this.totalPages = response.data.total_page;
            this.submittedData = response.data.data.data;
            this.studentcount = response.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style></style>
